import React, { useEffect, Children } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
const TermsOfUse = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full min-h-screen font-sans" data-id="element-571">
      <Navbar data-id="element-572" />
      <main className="container mx-auto px-4 py-12 max-w-4xl" data-id="element-573">
        <h1 className="text-3xl font-bold mb-6" data-id="element-574">
          FluidForm, Inc. — Terms of Service
        </h1>
        <p className="text-gray-600 mb-8" data-id="element-575">Last Updated: 08/16/2025</p>
        <section className="mb-8" data-id="element-576">
          <h2 className="text-xl font-semibold mb-4" data-id="element-577">1. Introduction</h2>
          <p className="mb-4" data-id="element-578">
            Welcome to FluidForm, Inc. ("FluidForm," "we," "us," or "our").
            These Terms of Service ("Terms") govern your access to and use of
            our products, services, websites, and applications (collectively,
            the "Services"). By accessing or using the Services, you agree to be
            bound by these Terms. If you do not agree, please do not use the
            Services.
          </p>
          <p className="mb-4" data-id="element-579">
            Company Information:
            <br data-id="element-580" />
            FluidForm, Inc.
            <br data-id="element-581" />
            2261 Market Street STE 85091 San Francisco, CA 94114
            <br data-id="element-582" />
            <a href="mailto:support@fluid-form.ai" className="text-blue-600 hover:underline" data-id="element-583">
              support@fluid-form.ai
            </a>
          </p>
        </section>
        <section className="mb-8" data-id="element-584">
          <h2 className="text-xl font-semibold mb-4" data-id="element-585">
            2. Eligibility / Minimum Age
          </h2>
          <p className="mb-4" data-id="element-586">
            You must be 13 years of age or older to use the Services.
            Individuals aged 13 through 17 may use the Services only with
            consent from a parent or legal guardian, who must accept these Terms
            on their behalf. Children under 13 are not permitted to use the
            Services.
          </p>
        </section>
        <section className="mb-8" data-id="element-587">
          <h2 className="text-xl font-semibold mb-4" data-id="element-588">
            3. Account Registration & Security
          </h2>
          <p className="mb-4" data-id="element-589">
            To access certain features, you may need to create an account. You
            agree to:
          </p>
          <ul className="list-disc pl-8 mb-4" data-id="element-590">
            <li className="mb-2" data-id="element-591">
              Provide accurate, current, and complete information.
            </li>
            <li className="mb-2" data-id="element-592">Safeguard your account credentials.</li>
            <li className="mb-2" data-id="element-593">
              Notify us immediately if you suspect unauthorized account use.
            </li>
          </ul>
          <p className="mb-4" data-id="element-594">
            You are responsible for all activities that occur under your
            account.
          </p>
        </section>
        <section className="mb-8" data-id="element-595">
          <h2 className="text-xl font-semibold mb-4" data-id="element-596">4. Acceptable Use</h2>
          <p className="mb-4" data-id="element-597">
            You may use the Services only for lawful purposes and in accordance
            with these Terms. You agree not to:
          </p>
          <ul className="list-disc pl-8 mb-4" data-id="element-598">
            <li className="mb-2" data-id="element-599">
              Engage in deceptive, harassing, or illegal activity.
            </li>
            <li className="mb-2" data-id="element-600">
              Interfere with or disrupt the Services (e.g., using bots,
              scraping, reverse engineering).
            </li>
            <li className="mb-2" data-id="element-601">
              Misuse or exploit features of the Services in unintended ways.
            </li>
          </ul>
          <p className="mb-4" data-id="element-602">
            Violation of this policy may result in suspension or termination of
            your account.
          </p>
        </section>
        <section className="mb-8" data-id="element-603">
          <h2 className="text-xl font-semibold mb-4" data-id="element-604">
            5. Subscriptions, Payments & Refunds
          </h2>
          <ul className="list-disc pl-8 mb-4" data-id="element-605">
            <li className="mb-2" data-id="element-606">
              Some Services are free; others require a paid subscription.
            </li>
            <li className="mb-2" data-id="element-607">
              Subscriptions automatically renew unless canceled before the
              renewal date.
            </li>
            <li className="mb-2" data-id="element-608">
              Payments are non-refundable, except as required by law.
            </li>
            <li className="mb-2" data-id="element-609">
              If you cancel, you retain access through the end of the billing
              period.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-610">
          <h2 className="text-xl font-semibold mb-4" data-id="element-611">
            6. Content Ownership & Rights
          </h2>
          <ul className="list-disc pl-8 mb-4" data-id="element-612">
            <li className="mb-2" data-id="element-613">
              You retain ownership of the content you create, submit, or upload
              ("Your Content").
            </li>
            <li className="mb-2" data-id="element-614">
              By using the Services, you grant FluidForm a non-exclusive,
              worldwide, royalty-free license to host, process, and display Your
              Content solely to operate and improve the Services.
            </li>
            <li className="mb-2" data-id="element-615">
              FluidForm does not claim ownership of Your Content.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-616">
          <h2 className="text-xl font-semibold mb-4" data-id="element-617">7. Privacy</h2>
          <p className="mb-4" data-id="element-618">
            Your use of the Services is governed by our Privacy Policy,
            available at [Privacy Policy URL]. Please review it to understand
            how we collect, use, and share your information.
          </p>
        </section>
        <section className="mb-8" data-id="element-619">
          <h2 className="text-xl font-semibold mb-4" data-id="element-620">
            8. Third-Party Integrations
          </h2>
          <p className="mb-4" data-id="element-621">
            The Services may integrate with third-party platforms (e.g., Slack,
            WhatsApp, CRMs). Your use of those integrations may be subject to
            additional third-party terms. We are not responsible for third-party
            services.
          </p>
        </section>
        <section className="mb-8" data-id="element-622">
          <h2 className="text-xl font-semibold mb-4" data-id="element-623">
            9. Service Availability
          </h2>
          <p className="mb-4" data-id="element-624">
            We aim to keep the Services reliable but cannot guarantee
            uninterrupted or error-free operation. We may modify, suspend, or
            discontinue the Services at any time without liability.
          </p>
        </section>
        <section className="mb-8" data-id="element-625">
          <h2 className="text-xl font-semibold mb-4" data-id="element-626">
            10. Warranties & Disclaimers
          </h2>
          <p className="mb-4" data-id="element-627">
            The Services are provided "as is" without warranties of any kind,
            express or implied. We disclaim all warranties, including
            merchantability, fitness for a particular purpose, and
            non-infringement.
          </p>
        </section>
        <section className="mb-8" data-id="element-628">
          <h2 className="text-xl font-semibold mb-4" data-id="element-629">
            11. Limitation of Liability
          </h2>
          <p className="mb-4" data-id="element-630">
            To the fullest extent permitted by law, FluidForm, its affiliates,
            officers, employees, and agents shall not be liable for indirect,
            incidental, special, consequential, or punitive damages, or for any
            loss of profits, revenues, or data.
          </p>
        </section>
        <section className="mb-8" data-id="element-631">
          <h2 className="text-xl font-semibold mb-4" data-id="element-632">
            12. Dispute Resolution & Arbitration
          </h2>
          <p className="mb-4" data-id="element-633">
            Most disputes can be resolved informally by contacting us at
            support@fluid-form.ai. If a dispute cannot be resolved informally,
            you and FluidForm agree that any claim or controversy arising out of
            or relating to these Terms or the Services will be resolved through
            binding individual arbitration, rather than in court, except that
            you may assert claims in small claims court if they qualify.
          </p>
          <p className="mb-4" data-id="element-634">
            Arbitration will be conducted by the American Arbitration
            Association (AAA) under its Commercial Arbitration Rules. The
            arbitration shall take place in San Francisco, California, or
            virtually if agreed by both parties.
          </p>
          <p className="mb-4" data-id="element-635">
            Class Action Waiver: All claims must be brought on an individual
            basis, not as part of a class or representative action.
          </p>
          <p className="mb-4" data-id="element-636">
            Opt-Out: You may opt out of arbitration within 30 days of first
            accepting these Terms by emailing support@fluid-form.ai with the
            subject line "Arbitration Opt-Out." If you opt out, disputes will be
            resolved in court subject to Section 13 (Governing Law).
          </p>
        </section>
        <section className="mb-8" data-id="element-637">
          <h2 className="text-xl font-semibold mb-4" data-id="element-638">13. Governing Law</h2>
          <p className="mb-4" data-id="element-639">
            These Terms are governed by the laws of the State of Delaware,
            without regard to its conflict of laws principles.
          </p>
        </section>
        <section className="mb-8" data-id="element-640">
          <h2 className="text-xl font-semibold mb-4" data-id="element-641">
            14. Changes to These Terms
          </h2>
          <p className="mb-4" data-id="element-642">
            We may update these Terms from time to time. If we make material
            changes, we will notify you (e.g., via email or notice in the
            Services). Continued use after changes take effect constitutes your
            acceptance.
          </p>
        </section>
        <section className="mb-8" data-id="element-643">
          <h2 className="text-xl font-semibold mb-4" data-id="element-644">15. Contact Us</h2>
          <p className="mb-4" data-id="element-645">
            If you have questions about these Terms, please contact us at:{' '}
            <a href="mailto:support@fluid-form.ai" className="text-blue-600 hover:underline" data-id="element-646">
              support@fluid-form.ai
            </a>
          </p>
        </section>
      </main>
      <Footer data-id="element-647" />
    </div>;
};
export default TermsOfUse;